import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs';
import { WatchedListEndpoints } from '../../config/watchedList/watchedlist-end-points';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WatchlistService {

  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }

  watch<T>(userId: number, IRNNumber : string): Observable<HttpResponse<T>> {
    return this.genericApiService.post(WatchedListEndpoints.Watch, { userId, IRNNumber  });
  }

  unwatch<T>(userId: number, IRNNumber : string): Observable<HttpResponse<T>> {
  return this.genericApiService.delete(`${WatchedListEndpoints.Unwatch}?userId=${userId}&IRNNumber=${IRNNumber }`);
}


isWatching(userId: number, IRNNumber: string): Observable<boolean> {
  return this.genericApiService.get<boolean>(
    `${WatchedListEndpoints.isWatching}?userId=${userId}&IRNNumber=${IRNNumber}`
  ).pipe(
    map(response => response.body ?? false) // safely extract the boolean
  );
}

  isWatchingBulk(userId: number, irnNumbers: string[]): Observable<string[]> {
    return this.genericApiService.post<string[]>(
      `${WatchedListEndpoints.IsWatchingBulk}?userId=${userId}`, irnNumbers
    ).pipe(
      map(response => response.body ?? [])
    );
  }
    
  }



